<div class="overflow-auto" *ngIf="!isMobile; else mobile">
  <table class="w-100 mat-elevated-item overflow-auto">
    <thead>
      <tr class="text-center" *ngIf="!isAdvancedColumns()">
        @if (allowSelection()) {
        <th>
          <mat-checkbox color="primary" (change)="changeAllCheckboxes($event)">
          </mat-checkbox>
        </th>
        } @for (column of columns(); track $index) {
        <th>
          {{ column.name }}
        </th>
        }

        <th *ngIf="actions()?.length">Ações</th>
      </tr>
      <tr *ngIf="isAdvancedColumns">
        <ng-content select="[slot=advanced-columns]"> </ng-content>
      </tr>
    </thead>
    <tbody class="text-center">
      @for (row of data; track $index; let rowIndex = $index) {
      <tr
        [ngClass]="{
          'bg-header-soft-color table-text-selected': row.selected
        }"
      >
        <td *ngIf="allowSelection()">
          <mat-checkbox
            color="primary"
            [checked]="row.selected"
            (change)="row.selected = $event.checked; verifySelectedCheckboxes()"
          >
          </mat-checkbox>
        </td>

        @for ( column of columns(); track $index) {
        <td>
          <app-table-cell [column]="column" [row]="row" [index]="rowIndex">
          </app-table-cell>
        </td>
        } @if (actions()?.length) {
        <td>
          <div class="d-flex align-items-center justify-content-center">
            @for (action of actions(); track $index) {
            <app-action-button
              [row]="row"
              [action]="action"
              (actionClick)="emitAction($event, rowIndex)"
            >
            </app-action-button>
            }
          </div>
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
</div>

<ng-template #mobile>
  <app-mobile-table [columns]="columns()" [actions]="actions()" [data]="data">
  </app-mobile-table>
</ng-template>
